import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import { ClientService } from '../../../services/client.service';
import { SectionService } from '../../../services/section.service';
import { ZorroModule } from '../../../modules/zorro.module';
import { AngularModule } from '../../../modules/angular.module';
import { Subscription } from 'rxjs';
import { H5pService } from '../../../services/h5p.service';
import { Loading } from '../../../services/loading';

@Component({
	selector: 'app-loading',
	standalone: true,
	imports: [ZorroModule, AngularModule],
	templateUrl: './loading.component.html',
	styleUrl: './loading.component.scss',
})
export class LoadingComponent implements OnInit, OnDestroy {
	public loading: boolean = false;
	private sub: Subscription | undefined;

	constructor(
		public loadingService: Loading,
		public adminService: AdminService,
		public clientService: ClientService,
		public sectionService: SectionService,
		public h5pService: H5pService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		// Initialize the loading state
		this.updateLoadingState();

		this.sub = this.loadingService.loading$.subscribe(isLoading => {
			this.loading = isLoading;
			this.cdr.detectChanges();
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}

	private updateLoadingState() {
		this.loading = this.loadingService.loading$.getValue();
		this.cdr.detectChanges();
	}
}
